export const SET_ACTIVE_ORDERS = 'SET_ACTIVE_ORDERS'
export const ADD_NEW_ACTIVE_ORDER = 'ADD_NEW_ACTIVE_ORDER'
export const UPDATE_ACTIVE_ORDER = 'UPDATE_ACTIVE_ORDER'
export const SET_DRAFT_ORDER_FLOW_ENABLED = 'SET_DRAFT_ORDER_FLOW_ENABLED'
export const SET_BMI_ORDER = 'SET_BMI_ORDER'
export const SET_PAYMENT_TYPES = 'SET_PAYMENT_TYPES'
